export const validateHubSpotData = (dataRows: string[], regex: RegExp, dataName: string) => {
  const validatedData: string[] = [];
  const invalidData: string[] = [];

  for (const row of dataRows) {
    if (row.length === 0) {
      // eslint-disable-next-line no-continue
      continue;
    }

    const parts = row.split(",");
    for (const part of parts) {
      const trimmed = part.trim();
      if (!regex.test(trimmed)) {
        invalidData.push(trimmed);
        // eslint-disable-next-line no-continue
        continue;
      }
      validatedData.push(trimmed);
    }
  }

  const errorMessage =
    invalidData.length > 0 ? `The file loaded with the following invalid ${dataName}: ${invalidData.join(", ")}` : "";
  return { validatedData, errorMessage };
};
